import { createLoader, parseAsStringLiteral } from 'nuqs/server';
import type { Tenure } from './store';

const keyMaps = {
  tenure: parseAsStringLiteral<Tenure>(['Bostadsrätt', 'Äganderätt']),
};

const tenureLoader = createLoader(keyMaps);

export { keyMaps, tenureLoader };
